import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';
import {
  IUseWorkflowStepGeneratedDocumentParams,
  IWorkflowStepGeneratedDocumentResponse,
} from './types';

export const useWorkflowStepGeneratedDocument = (
  params: IUseWorkflowStepGeneratedDocumentParams | null
) => {
  // Null until the preview is actually opened, so the document is only fetched on demand.
  const url = params
    ? `${WORKFLOW_EXECUTION_BASE_URL}/${params.workflowExecutionId}/step/${params.stepId}/generated-document`
    : null;

  const { data, error, isLoading } =
    useSWR<IWorkflowStepGeneratedDocumentResponse>(
      url,
      SWRFetcher({ method: 'GET' })
    );

  return { data, error, isLoading };
};
